import { render, staticRenderFns } from "./ScreenPage.vue?vue&type=template&id=1711b5b8"
import script from "./ScreenPage.vue?vue&type=script&lang=js"
export * from "./ScreenPage.vue?vue&type=script&lang=js"
import style0 from "./ScreenPage.vue?vue&type=style&index=0&id=1711b5b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports